var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      staticClass: "dot-pattern-background",
      style: { opacity: _vm.opacity },
      attrs: { xmlns: "http://www.w3.org/2000/svg", "aria-hidden": "true" }
    },
    [
      _c("defs", [
        _c(
          "pattern",
          {
            attrs: {
              id: _vm.patternId,
              width: _vm.spacing,
              height: _vm.spacing,
              patternUnits: "userSpaceOnUse"
            }
          },
          [
            _c("circle", {
              attrs: {
                cx: _vm.dotSize,
                cy: _vm.dotSize,
                r: _vm.dotSize,
                fill: _vm.color
              }
            })
          ]
        )
      ]),
      _c("rect", {
        attrs: {
          width: "100%",
          height: "100%",
          fill: "url(#" + _vm.patternId + ")"
        }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }